import React from 'react'
import styled, { keyframes } from 'styled-components'

import Spinner from '../../assets/icons/spinner'

const rotate = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
`

const Svg = styled.svg`
  fill: #ffffff;
  width: 16px;
  height: 16px;
  animation: ${rotate} 1s linear infinite;
`

export const SpinnerIcon = ({ className }) => {
  return <Svg as={Spinner} className={className} />
}
